const mon_p = document.createElement("p");

(async() =>{
    mon_p.textContent = await (async () => {
        const fetch_promise = await fetch(`${process.env.BACKEND_SERV_URL}/index.php`);
        let textContent_fetched = await fetch_promise.text();
        return textContent_fetched;
    }) ();
    console.log("mon_p.textContent : " + mon_p.textContent);
}) ();



document.querySelector("body").appendChild(mon_p);